if (!customElements.get('purchase-options')) {
  customElements.define(
    'purchase-options',
    class PurchaseOptions extends HTMLElement {
      connectedCallback() {
        this.sellingPlanInput = this.querySelector('input[name="selling_plan"]');
        this.prices = JSON.parse(this.querySelector('[data-prices]').textContent);
        this.variantId = this.dataset.variantId;

        this.addEventListener('change', this.onChange.bind(this));
        this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
          // Other products on the page (quick add, featured product) publish the same event.
          if (!data.variant || !this.prices[data.variant.id]) return;
          this.variantId = String(data.variant.id);
          this.update();
        });

        this.update();
      }

      disconnectedCallback() {
        this.unsubscribe?.();
      }

      onChange(event) {
        // Choosing a delivery frequency also chooses that subscription.
        if (event.target.matches('[data-plans]')) {
          event.target.closest('.purchase-option').querySelector('input[type="radio"]').checked = true;
        }
        this.update();
      }

      update() {
        const prices = this.prices[this.variantId];
        if (!prices) return;

        const options = [...this.querySelectorAll('.purchase-option')].map((element) => ({
          element,
          radio: element.querySelector('input[type="radio"]'),
          planId: element.querySelector('[data-plans]')?.value,
        }));

        options.forEach(({ element, radio, planId }) => {
          const price = planId ? prices.plans[planId] : prices.price;
          radio.disabled = !price;
          if (price) element.querySelector('[data-price]').textContent = price;
        });

        // Fall back to the first available choice when this variant doesn't offer the checked one.
        let selected = options.find(({ radio }) => radio.checked && !radio.disabled);
        if (!selected) {
          selected = options.find(({ radio }) => !radio.disabled);
          if (selected) selected.radio.checked = true;
        }

        options.forEach(({ element }) => element.classList.toggle('is-selected', element === selected?.element));
        this.sellingPlanInput.value = selected?.planId ?? '';

        const submitPrice = this.closest('product-info')?.querySelector('.product-form__submit-price');
        if (submitPrice && selected) {
          submitPrice.textContent = selected.planId ? prices.plans[selected.planId] : prices.price;
        }

        // Accelerated checkout buttons can't start a subscription, so only offer them for one-time purchases.
        this.closest('product-info')
          ?.querySelector('.shopify-payment-button')
          ?.classList.toggle('hidden', this.sellingPlanInput.value !== '');
      }
    }
  );
}
